<div class="modal-background" bdFxLayoutAlign="center start">
    <div class="projects-modal">
        <div class="header">
            <div class="title">
                {{agreement?.agreementFileName}}
            </div>
            <div class="save">
                <bd-fa-button [name]="'times'" (click)="onCancelBtnClicked()"></bd-fa-button>
            </div>
        </div>


        <div class="body">

            <div class="iframe-container">
                <div *ngIf="!initialized && !isError" class="spinner">Wird geladen ...</div>
                <div *ngIf="!initialized && isError" class="spinner">Some error occurred during the agreement document loading.</div>
                <iframe type="application/pdf" height="100%" #pdfIframe class="iframe" width="100%">
                </iframe>
            </div>
            <div class="download-button-container" (click)="onDownloadBtnClicked()">
                <bd-fa [name]="'download'"></bd-fa>
                <span>Dokument herunterladen</span>
            </div>

            <bd-checkbox-squared name="isAgreed" class="color-secondary" [(ngModel)]="isAgreed" checkboxColor="'black'">
                <span>Ich stimme den Nutzungsbedingungen zu.</span>
            </bd-checkbox-squared>
        </div>

        <div class="footer">
            <button class="pr-btn active" type="button" (click)="onConfirmBtnClicked()" #focusedButton
                    [disabled]="!isAgreed || !initialized">
                Bestätigen
            </button>
        </div>


    </div>
</div>
